import { getDocument } from '../../common/dom-helpers'
import { getDialogService } from '../dialog/public-facade'
import { getFeatureFlagValue } from '../feature-flags'
import { FeatureFlagsVariations } from '../feature-flags/models'
import { getNamespaces } from '.'
import { GotoChatbot } from '../../packages/chatbot/chatbot'

export const CHATBOT_NAMESPACE = 'chatbot'

export interface ChatbotNamespace {
  readonly commands: {
    openChatbot(): void
  }
}

export const setupChatbotCommands = async () => {
  const chatbotNamespace = getNamespaces().retrieve<ChatbotNamespace>(CHATBOT_NAMESPACE)
  const isChatbotEnabled = !!getFeatureFlagValue(FeatureFlagsVariations.SHELL_CHATBOT)

  if (isChatbotEnabled) {
    chatbotNamespace.commands.openChatbot.addHandler(() => {
      getDialogService().open(getDocument().createElement(GotoChatbot.tagName))
    })
  }
}
